export default __webpack_public_path__ + "static/media/ruth.64a5a834.webp";